module.exports = __webpack_public_path__ + "img/table.e7edb425.png";